export const BLOG_POSTS_INDEX = 10 as const;
export const BLOG_POSTS_PER_PAGE = 12 as const;
export const BLOG_AUTHOR_POSTS_PER_PAGE = 9 as const;

export const DEFAULT_BLOG_AUTHOR_ID = 'generation-tux' as const;
